module.exports = __webpack_public_path__ + "static/img/290_TO8_2464_og.3785a29.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/290_TO8_2464_og.jpg
// module id = iim2
// module chunks = 0